<template>
  <div>
    <RightTitle title="绑定邮箱"></RightTitle>
    <!-- 表单 -->
    <div class="uar_form">
      <blockquote
        class="layui-elem-quote layui-quote-nm"
        v-if="showBindEmailNotice"
      >首次绑定邮箱赠送{{ bindEmailIntegral }}积分</blockquote>
      <el-form ref="form" :model="form" label-width="100px" size="medium">
        <el-form-item label="邮箱">
          <el-input
            class="space"
            v-model="form.email"
            clearable
            style="width:200px;"
            :placeholder="emailPlaceholder"
            :readonly="emailReadonly"
          ></el-input>
          <el-button
            type="primary"
            @click="sendEmailCode"
            :disabled="sendButtonDesabled"
            :loading="buttonLoading"
          >{{ sendButtonText }}</el-button>
        </el-form-item>
        <el-form-item label="邮箱验证码">
          <el-input
            v-model="form.emailCode"
            clearable
            :placeholder="emailCodePlaceholder"
            style="width:320px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="滑动验证">
          <Verify
            :type="3"
            :showButton="false"
            :barSize="{width:'320px',height:'40px'}"
            @success="slideSuccess"
            @ready="slideReady"
          ></Verify>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm">立即提交</el-button>
          <el-button @click="resetForm('form')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// 记载组件
import RightTitle from "../../../components/RightTitle";
import Verify from "vue2-verify";
// 加载api
import {
  getUserInfo,
  sendEmailCode,
  bindEmail,
  checkEmailCode
} from "../../../api/user";
import { getBaseConfig } from "../../../api/index";
// 加载函数
import { checkEmail } from "../../../utils/fn";
export default {
  name: "person_bindemail",
  components: {
    RightTitle,
    Verify
  },
  beforeRouteEnter(to, from, next) {
    getUserInfo().then(res => {
      next(vm => {
        vm.form.email = res.data.email;
        if (res.data.email != "") {
          vm.emailReadonly = true;
          vm.showBindEmailNotice = false;
        }
      });
    });
  },
  beforeRouteUpdate(to, from, next) {
    getUserInfo().then(res => {
      this.form.email = res.data.email;
      if (res.data.email != "") {
        this.emailReadonly = true;
        this.showBindEmailNotice = false;
      }
      next();
    });
  },
  mounted() {
    getBaseConfig({
      type: "user_integral_config"
    }).then(res => {
      if (res.status == 200) {
        // 获取首次绑定邮箱赠送积分
        let userIntegralConfig = res.data["user_integral_config"];
        let bindEmailIntegralConfig = userIntegralConfig[10];
        this.bindEmailIntegral = bindEmailIntegralConfig.value;
      }
    });
  },
  data() {
    return {
      form: {
        email: "",
        emailCode: ""
      },
      showBindEmailNotice: true,
      emailReadonly: false,
      isVerify: false,
      sendButtonText: "发送验证码",
      sendButtonDesabled: false,
      limitTime: 120,
      bindEmailIntegral: 0,
      buttonLoading: false,
      bindType: 1,
      slideObj: {},
      timer: {},
      emailPlaceholder: "请输入邮箱",
      emailCodePlaceholder: "请输入邮箱验证码"
    };
  },
  methods: {
    // 初始化验证组件
    slideReady(obj) {
      this.slideObj = obj;
    },
    slideSuccess() {
      this.isVerify = true;
    },
    //   提交
    submitForm() {
      if (!this.isVerify) {
        this.$notify({
          title: "警告",
          message: "请滑动滑块验证后再提交",
          type: "warning"
        });
        return false;
      }
      if (this.form.emailCode == "") {
        this.$notify({
          title: "警告",
          message: "请输入邮箱验证码",
          type: "warning"
        });
        return false;
      }
      if (this.emailReadonly == false) {
        // 用户填写的邮箱
        bindEmail({
          type: this.bindType,
          email: this.form.email,
          emailCode: this.form.emailCode
        }).then(res => {
          if (res.status == 200) {
            this.$notify({
              title: "成功",
              message: res.message,
              type: "success"
            });
            clearTimeout(this.timer);
            this.slideObj.refresh();
            this.emailReadonly = true;
            this.sendButtonDesabled = false;
            this.sendButtonText = "发送验证码";
            this.showBindEmailNotice = false;
            this.form.emailCode = "";
            this.isVerify = false;
            this.emailPlaceholder = "请输入邮箱";
            this.emailCodePlaceholder = "请输入邮箱验证码";
          } else {
            this.$notify({
              title: "警告",
              message: res.message,
              type: "warning"
            });
            return false;
          }
        });
      } else {
        // 验证原来的邮箱
        checkEmailCode({
          type: this.bindType,
          emailCode: this.form.emailCode
        }).then(res => {
          if (res.status == 200) {
            clearTimeout(this.timer);
            this.slideObj.refresh();
            this.emailReadonly = false;
            this.sendButtonDesabled = false;
            this.sendButtonText = "发送验证码";
            this.showBindEmailNotice = false;
            this.form.email = "";
            this.form.emailCode = "";
            this.isVerify = false;
            this.emailPlaceholder = "请输入新邮箱";
            this.emailCodePlaceholder = "请输入新邮箱验证码";
          } else {
            this.$notify({
              title: "警告",
              message: res.message,
              type: "warning"
            });
            return false;
          }
        });
      }
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 发送邮箱验证码
    sendEmailCode() {
      if (!this.isVerify) {
        this.$notify({
          title: "警告",
          message: "请滑动滑块验证后再发送",
          type: "warning"
        });
        return false;
      }
      let sendEmail = "";
      if (this.emailReadonly == false) {
        if (this.form.email == "") {
          this.$notify({
            title: "警告",
            message: "请输入邮箱",
            type: "warning"
          });
          return false;
        }
        if (!checkEmail(this.form.email)) {
          this.$notify({
            title: "警告",
            message: "请输入正确的邮箱格式",
            type: "warning"
          });
          return false;
        }
        sendEmail = this.form.email;
      }

      this.buttonLoading = true;
      sendEmailCode({ type: this.bindType, email: sendEmail }).then(res => {
        if (res.status == 200) {
          this.$notify({
            title: "成功",
            message: res.message,
            type: "success"
          });
          this.buttonLoading = false;
          // 设置按钮状态
          this.setSendButtonStatus();
        } else {
          this.$notify({
            title: "警告",
            message: res.message,
            type: "warning"
          });
          this.buttonLoading = false;
          return false;
        }
      });
    },
    // 设置发送按钮状态
    setSendButtonStatus() {
      if (this.limitTime > 0) {
        this.timer = setTimeout(() => {
          this.limitTime -= 1;
          this.sendButtonDesabled = true;
          this.sendButtonText = this.limitTime + " 秒";
          this.setSendButtonStatus();
        }, 1000);
      } else {
        this.limitTime = 120;
        this.sendButtonDesabled = false;
        this.sendButtonText = "发送验证码";
      }
    }
  }
};
</script>

<style scoped>
</style>